import { mutator } from 'satcheljs';
import type { MailRibbonConfigStore } from '../store/schema/mailRibbonConfigStore';
import { getStore } from '../store/store';
import loadMailRibbonConfiguration from '../actions/loadMailRibbonConfiguration';
import { getMailRibbonConfigFromString } from '../util/getMailRibbonConfigFromString';

mutator(loadMailRibbonConfiguration, () => {
    /*
    WIP (ADO119406): This will eventually get the user's preferences, but right
    now gets default configuration.
    */
    const store = getStore();
    const mailRibbonDefaultConfig: MailRibbonConfigStore = getMailRibbonConfigFromString('');
    store.multiline.homeTab = mailRibbonDefaultConfig.multiline.homeTab;
    store.multiline.viewTab = mailRibbonDefaultConfig.multiline.viewTab;
    store.multiline.messageTab = mailRibbonDefaultConfig.multiline.messageTab;
    store.multiline.formatTab = mailRibbonDefaultConfig.multiline.formatTab;
    store.singleline.homeTab = mailRibbonDefaultConfig.singleline.homeTab;
    store.singleline.viewTab = mailRibbonDefaultConfig.singleline.viewTab;
    store.singleline.messageTab = mailRibbonDefaultConfig.singleline.messageTab;
    store.singleline.formatTab = mailRibbonDefaultConfig.singleline.formatTab;
    store.toolbar.homeTab = mailRibbonDefaultConfig.toolbar.homeTab;
    store.toolbar.messageTab = mailRibbonDefaultConfig.toolbar.messageTab;
});
